import { Component, OnInit, ViewChild } from '@angular/core';
import {  MatSort } from '@angular/material/sort';
import {  MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { News } from '../models/news';
import { NewsDialogComponent } from './dialogs/news-dialog/news-dialog.component';
import { NewsService } from '../services/news.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  entryComponents: [
    NewsDialogComponent
  ]
})
export class NewsComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'title', 'active', 'created', 'edit', 'delete'];

  constructor(
    private fs: AngularFireStorage,
    public _newsService: NewsService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate(['home']);
    }

    this.loadNews()
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadNews() {

    this.sub = this._newsService.select()
      .subscribe((result) => {
        let array = result.map(item => {
          let entity = new News();

          entity.id = item.payload.doc.id;
          entity.active = item.payload.doc.data().active;
          entity.created = item.payload.doc.data().created;

          entity.title = item.payload.doc.data().title;
          entity.title_en = item.payload.doc.data().title_en;

          entity.text_home = item.payload.doc.data().text_home;
          entity.text_home_en = item.payload.doc.data().text_home_en;

          entity.text = item.payload.doc.data().text;
          entity.text_en = item.payload.doc.data().text_en;

          entity.image = item.payload.doc.data().image;
          entity.image_en = item.payload.doc.data().image_en;

          return entity;
        });

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: News = new News();

    if (entity) {
      data = entity;
    }

    this.dialog.open(NewsDialogComponent, {
      width: '900px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }

  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '280px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.title + "<br><br>Excluir esta notícia?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._newsService.spinner = true;

        const news_id = element.id

        this._newsService.delete(element.id)
          .then(
            () => {
              const newsRef = this.fs.storage.ref('images/news/' + news_id + "_pt.png");
              newsRef.delete()
              .then(function () {
              }).catch(function (error) {
                console.log("image pt error" + JSON.stringify(error))
              })
              .finally(()=>{
                this._newsService.spinner = false;   
              });

              const newsRef_en = this.fs.storage.ref('images/news/' + news_id + "_en.png");
              newsRef_en.delete().then(function () {
              }).catch(function (error) {
                console.log("image en error" + JSON.stringify(error))
              });

              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete news error: " + error.message) }
          )
      }
    })
  }

}
